import { TextField, TextFieldProps } from "@material-ui/core";
import React from "react";

export default (props: TextFieldProps) => {
  var { value, ...other } = props;

  return <TextField {...other} value={value ?? ""} />;
};
